import { ability, updateAbilityWithPerm } from 'utils/permissions';
import { CAN_SEE_COVERAGE } from 'constants/misc';
import {
  GET_CONFIG,
} from '../actions/configActions';

const initialState = {
  config: {
    loading: true,
    loaded: false,
    emailBackend: 'mailgun',
    canSeeCoverage: false,
    opportunityRotting: false,
  },
};


export default function (state = initialState.config, action) {
  switch (action.type) {
    case GET_CONFIG.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_CONFIG.success: {
      const canSeeCoverage = action.payload.data && action.payload.data.can_see_coverage;
      if (canSeeCoverage) { updateAbilityWithPerm(ability, CAN_SEE_COVERAGE); }
      return {
        loading: false,
        loaded: true,
        canSeeCoverage,
        opportunityRotting: action.payload.data && action.payload.data.opportunity_rotting,
        emailBackend: action.payload.data ?
          action.payload.data.email_backend : undefined,
      };
    }
    default:
      return state;
  }
}
